export const CASE_ENTITY_CRS_PRESET_REASON = [
  'Reason A - The country/jurisdiction where Account Holder is liable to pay tax does not issue TIN to its residents.',
  'Reason B - The Account Holder is otherwise unable to obtain a TIN or equivalent number.',
  'Reason C - No TIN is required (note: only select this reason if the authorities of the country of residence for tax purposes do not require the TIN to be disclosed).',
] as const;
